import { render, staticRenderFns } from "./BtnGroup.vue?vue&type=template&id=3bd65a33&scoped=true"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"
import style0 from "./BtnGroup.vue?vue&type=style&index=0&id=3bd65a33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd65a33",
  null
  
)

export default component.exports